var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _line, _line2, _line3, _line4, _path4, _path5, _path6, _line5, _line6, _line7, _line8, _path7, _path8, _path9, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _text, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect4, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _polygon, _polygon2, _polygon3, _rect5, _g, _path58, _path59, _path60, _path61, _path62, _g2, _g3, _path63, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _circle, _path64, _path65;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutusn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-17,.cls-21,.cls-27,.cls-30,.cls-31,.cls-5,.cls-6{fill:none;}.cls-2{fill:#d9c4df;}.cls-11,.cls-3{fill:#2e1f42;}.cls-4{fill:#fff;}.cls-10,.cls-30,.cls-31,.cls-5,.cls-6{stroke:#2e1f42;}.cls-10,.cls-17,.cls-21,.cls-27,.cls-30,.cls-31,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-5{stroke-width:1.28px;}.cls-6{stroke-width:2.2px;}.cls-7{fill:#82d4f6;}.cls-8{fill:#cbe6ef;}.cls-9{fill:#fdc437;}.cls-11{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-12{fill:#f2d686;}.cls-13{fill:#fec536;}.cls-14{fill:#f8a582;}.cls-15{fill:#dfd4e9;}.cls-16{fill:#9a499c;}.cls-17,.cls-21{stroke:#213242;}.cls-17{stroke-width:1.36px;}.cls-18{fill:#f47755;}.cls-19{fill:#e95343;}.cls-20{fill:#51687c;}.cls-21{stroke-width:0.58px;}.cls-22{fill:#9ea5ad;}.cls-23{fill:#a0813a;}.cls-24{fill:#3b5972;}.cls-25{opacity:0.5;}.cls-26{clip-path:url(#clip-path);}.cls-27{stroke:#4f4e4f;stroke-width:1.85px;}.cls-28{clip-path:url(#clip-path-2);}.cls-29{clip-path:url(#clip-path-3);}.cls-30{stroke-width:2.63px;}.cls-31{stroke-width:7.66px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1167.02,
    y: 162.42,
    width: 77.5,
    height: 87.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1178.99,
    y: 169.1,
    width: 18.88,
    height: 17.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1175.2,
    y: 166.57,
    width: 26.47,
    height: 24.87
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ABOUT US N") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 628.51,
    y: 68.31,
    width: 75.02,
    height: 3.24,
    transform: "translate(99.13 426.44) rotate(-38.16)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1021.61,
    y: 256.01,
    width: 75.02,
    height: 3.24,
    transform: "translate(67.16 709.43) rotate(-38.16)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M934.46,60.43a6.62,6.62,0,1,1-6.62-6.62,6.62,6.62,0,0,1,6.62,6.62",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M957.44,86.05a6.63,6.63,0,1,1-6.62-6.62,6.63,6.63,0,0,1,6.62,6.62",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M960.68,45.81a6.62,6.62,0,1,1-3.85-8.54,6.62,6.62,0,0,1,3.85,8.54",
    transform: "translate(0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 933.45,
    y1: 56.93,
    x2: 949.04,
    y2: 47.11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 933.45,
    y1: 56.93,
    x2: 949.04,
    y2: 47.11
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.93,
    y1: 66.71,
    x2: 946.19,
    y2: 82.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 929.93,
    y1: 66.71,
    x2: 946.19,
    y2: 82.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1443.32,92.87a11.36,11.36,0,1,1-15.81,2.85,11.35,11.35,0,0,1,15.81-2.85",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1501.88,85.57a11.35,11.35,0,1,1-15.8,2.84,11.35,11.35,0,0,1,15.8-2.84",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1448.38,41.63a11.36,11.36,0,1,1-15.79-2.94,11.35,11.35,0,0,1,15.79,2.94",
    transform: "translate(0)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1437.4,
    y1: 90.86,
    x2: 1438.82,
    y2: 59.29
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1437.4,
    y1: 90.86,
    x2: 1438.82,
    y2: 59.29
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1447.73,
    y1: 105.39,
    x2: 1485.61,
    y2: 97.74
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1447.73,
    y1: 105.39,
    x2: 1485.61,
    y2: 97.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.28,61.43l-8.92.86A23.4,23.4,0,0,0,67,62.86c-7.61-1.61-14.79.75-18.25,5.92a15.8,15.8,0,0,0-2.16,8A15.39,15.39,0,0,0,61.9,92.1h59.38a15.34,15.34,0,1,0,0-30.67",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145,58.3l-7.3.7a19.16,19.16,0,0,0-37.16.47c-6.23-1.32-12.11.61-15,4.85a13,13,0,0,0-1.76,6.54A12.59,12.59,0,0,0,96.4,83.41H145a12.56,12.56,0,1,0,0-25.11",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.94,265.89h0a13.67,13.67,0,0,0-.15-4.38h0l2-2.72-1.38-3-3.35-.31,0,0a13.86,13.86,0,0,0-3.2-3h0l-.52-3.32L112.18,248l-2.59,2.15v0a14.27,14.27,0,0,0-4.38.15h0l-2.72-2-3,1.37L99.14,253l0,0a14.25,14.25,0,0,0-3,3.2h0l-3.32.53-1.18,3.12,2.15,2.59h0a14,14,0,0,0,.15,4.38h0l-2,2.73,1.37,3,3.35.31,0,0a14,14,0,0,0,3.2,3h0l.53,3.33,3.12,1.17,2.59-2.15v0a14,14,0,0,0,4.38-.16v0l2.72,2,3-1.38.31-3.35h0a14.07,14.07,0,0,0,3-3.21h0l3.32-.52,1.18-3.12Zm-3.43,2.32a11.37,11.37,0,1,1-6.6-14.67,11.38,11.38,0,0,1,6.6,14.67",
    transform: "translate(0)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 515.18,
    y1: 312.23,
    x2: 560.81,
    y2: 266.6
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 531.64,
    y1: 298.89,
    x2: 577.27,
    y2: 253.26
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 535.79,
    y1: 301.74,
    x2: 564.87,
    y2: 272.66
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 529.82,
    y1: 310.32,
    x2: 558.9,
    y2: 281.24
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 540.44,
    y1: 302.37,
    x2: 569.53,
    y2: 273.28
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 517.63,
    y1: 316.11,
    x2: 563.26,
    y2: 270.48
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 525.63,
    y1: 298.21,
    x2: 571.26,
    y2: 252.58
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 527.04,
    y1: 293.54,
    x2: 546.8,
    y2: 273.79
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 528.67,
    y1: 287.99,
    x2: 539.86,
    y2: 276.8
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 531.33,
    y1: 281.67,
    x2: 542.51,
    y2: 270.48
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 545.23,
    y1: 301.37,
    x2: 556.41,
    y2: 290.19
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1303.1,
    y1: 292.03,
    x2: 1348.73,
    y2: 246.4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1319.56,
    y1: 278.68,
    x2: 1365.18,
    y2: 233.05
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1323.71,
    y1: 281.54,
    x2: 1352.79,
    y2: 252.45
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1317.74,
    y1: 290.12,
    x2: 1346.82,
    y2: 261.04
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1328.36,
    y1: 282.16,
    x2: 1357.44,
    y2: 253.08
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1305.55,
    y1: 295.91,
    x2: 1351.18,
    y2: 250.28
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1313.55,
    y1: 278,
    x2: 1359.18,
    y2: 232.37
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1314.96,
    y1: 273.34,
    x2: 1334.72,
    y2: 253.58
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1316.59,
    y1: 267.78,
    x2: 1327.78,
    y2: 256.6
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1319.25,
    y1: 261.46,
    x2: 1330.43,
    y2: 250.28
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1333.15,
    y1: 281.17,
    x2: 1344.33,
    y2: 269.98
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(647.72 200.64)"
  }, "ABOUT US")), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241.13,190c2.12,11.06-7,18.9-17.38,14.64-3.42-1.41-6.87-4.13-9.94-8.91-11.7-18.2-5.78-33.81,10.51-32.2,10.06,1,14.72,15.5,16.81,26.47",
    transform: "translate(0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.14,73.17c-11,2.3-19-6.71-14.93-17.13,1.35-3.45,4-6.94,8.73-10.1,18-12,33.71-6.35,32.38,10-.81,10.07-15.25,15-26.18,17.26",
    transform: "translate(0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M352.64,142.12c1.95,17.84,13.6,57.69,21.67,65.5,10.49,10.16,45.05,31.56,63.05,42.53,3.24,2-12,15.16-12,15.16s-47.79-20.43-66-36.55c-5.16-4.55-15.64-18.93-27.48-46.31-3.58-8.3-12.28-25-11.83-36,.52-12.56,20.48-10.49,32.64-4.36",
    transform: "translate(0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M389.93,244.6s13,4.93,17.6,10.36,10.69,10,9.21,12.18-8.22-4.12-8.22-4.12-1.85,6.87-8.39,7.62-18.92-12.06-18.92-12.06Z",
    transform: "translate(0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.63,191.93c0,1.13,0,2.46,0,4s.06,3.19.1,5q.06,1.89.12,4c.05,1.17.09,2.4.14,3.66s.12,2.63.18,4c.91,18.69,3.1,44.48,7.91,65.16H371.22c-3.38-15-8.54-38.73-12.63-69.49-.17-1.3-.34-2.6-.51-3.92s-.33-2.65-.5-4c-.09-.71-.17-1.43-.26-2.15s-.13-1.19-.2-1.78c-.19-1.65-.36-3.29-.51-4.89-.13-1.33-.25-2.64-.36-3.94-1.73-20.68-1.12-36.18-3.61-45.46-2.9-10.81-36.74-23.2-36.74-23.2L294.7,120s-20.22,6.6-31,16.09-1.77,37.8-2,53.88c0,.55,0,1.2,0,1.93",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M261.65,195.91a237.63,237.63,0,0,0,28.2,1.55,418.34,418.34,0,0,0,66.76-5.94c-.13-1.33-.25-2.64-.36-3.94-8.14,1.44-55.25,9.23-94.62,4.35,0,1.13,0,2.46,0,4",
    transform: "translate(0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M261.75,200.94q.06,1.89.12,4a238.19,238.19,0,0,0,28,1.52,417.16,417.16,0,0,0,67.73-6.11c-.09-.71-.17-1.43-.26-2.15s-.13-1.19-.2-1.78c-4.69.86-54.22,9.6-95.37,4.53",
    transform: "translate(0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M262,208.59c.06,1.29.12,2.63.18,4a233.35,233.35,0,0,0,29.19,1.68,418.65,418.65,0,0,0,67.21-6c-.17-1.3-.34-2.6-.51-3.92-7.3,1.3-56,9.5-96.07,4.25",
    transform: "translate(0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M309.78,139.26c-10.54,0-20.27-11.2-20.69-11.69a.75.75,0,0,1,.08-1,.74.74,0,0,1,1.05.08c.1.12,10.29,11.85,20.47,11.14a.74.74,0,0,1,.79.69.75.75,0,0,1-.69.8c-.34,0-.67,0-1,0",
    transform: "translate(0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.78,139.26c-10.54,0-20.27-11.2-20.69-11.69a.75.75,0,0,1,.08-1,.74.74,0,0,1,1.05.08c.1.12,10.29,11.85,20.47,11.14a.74.74,0,0,1,.79.69.75.75,0,0,1-.69.8C310.45,139.25,310.12,139.26,309.78,139.26Z",
    transform: "translate(0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M300.64,265.27a.74.74,0,0,1-.08-1.48c27.23-3.13,38.51-50.27,38.62-50.74a.74.74,0,1,1,1.45.33c-.46,2-11.64,48.63-39.9,51.89h-.09",
    transform: "translate(0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.64,265.27a.74.74,0,0,1-.08-1.48c27.23-3.13,38.51-50.27,38.62-50.74a.74.74,0,1,1,1.45.33c-.46,2-11.64,48.63-39.9,51.89Z",
    transform: "translate(0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M311.49,251a.77.77,0,0,1-.64-.35.76.76,0,0,1,.24-1c14.49-8.93,16.64-22.09,16.66-22.22a.73.73,0,0,1,.85-.62.74.74,0,0,1,.62.84c-.08.57-2.25,14-17.34,23.27a.82.82,0,0,1-.39.11",
    transform: "translate(0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M311.49,251a.77.77,0,0,1-.64-.35.76.76,0,0,1,.24-1c14.49-8.93,16.64-22.09,16.66-22.22a.73.73,0,0,1,.85-.62.74.74,0,0,1,.62.84c-.08.57-2.25,14-17.34,23.27A.82.82,0,0,1,311.49,251Z",
    transform: "translate(0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.86,69.93A29.83,29.83,0,1,1,303,40.1a29.84,29.84,0,0,1,29.83,29.83",
    transform: "translate(0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.7,74.09s6.64,1.07,5.53-7.13c-1-7,5.79-3.39,5.42-9.79-.72-12.33-7.27-8.61-13.57-12.12-2.69-1.5-4-8.78-16.82-12.4C293.05,27.23,285.55,49.37,277,49.87c-12.6.74-6.51,8.19-7.75,13.89s4.85,11.36,4.85,11.36Z",
    transform: "translate(0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M327.85,78.28s4.72-6.3,8.24-1.09S334.63,97.78,326,94Z",
    transform: "translate(0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M327.91,89.27a.73.73,0,0,0,.7-.53c1.33-4.75,6.25-6.68,6.3-6.69a.72.72,0,0,0,.42-.94.71.71,0,0,0-.93-.42c-.23.08-5.66,2.19-7.19,7.66a.72.72,0,0,0,.5.89.69.69,0,0,0,.2,0",
    transform: "translate(0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.88,86.88a.71.71,0,0,0,.39-.12.72.72,0,0,0,.22-1,6.61,6.61,0,0,0-2.73-2.2.73.73,0,0,0-.59,1.33,5.2,5.2,0,0,1,2.09,1.66.75.75,0,0,0,.62.33",
    transform: "translate(0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M293.58,107.08v15.3s6.29,6.74,12.46,7.27,9.91-6.78,9.91-6.78V108.15Z",
    transform: "translate(0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M293.58,107.08v6.79c4.14,4.59,11.49,5.74,22.37,4.13v-9.85Z",
    transform: "translate(0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M277.44,67.78a150.79,150.79,0,0,0,2,19.33c.28,1.48.6,2.88,1,4.13,3.22,11.27,11.27,30.61,33.82,22.55,10-3.55,14.58-14.64,16.64-25.93a109.58,109.58,0,0,0,1.5-20.93,16,16,0,0,0-8.11-13.6c-13.31-7.54-27.35-4.73-36.6-1.17a15.92,15.92,0,0,0-10.2,15.62",
    transform: "translate(0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.51,80.27c0,1.64.84,3,1.88,3s1.88-1.32,1.88-3-.84-3-1.88-3-1.88,1.32-1.88,3",
    transform: "translate(0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.49,80.27c0,1.64.85,3,1.88,3s1.88-1.32,1.88-3-.84-3-1.88-3-1.88,1.32-1.88,3",
    transform: "translate(0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M324.51,71.19s-6.76-2.67-12.55-1A1.54,1.54,0,0,0,310.89,72h0a1.54,1.54,0,0,0,1.72,1.26,26,26,0,0,1,10.07.7,1.55,1.55,0,0,0,1.93-1,2.57,2.57,0,0,0-.1-1.73",
    transform: "translate(0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.69,71.19s6.76-2.67,12.55-1A1.54,1.54,0,0,1,302.31,72h0a1.54,1.54,0,0,1-1.72,1.26,26,26,0,0,0-10.07.7,1.55,1.55,0,0,1-1.93-1,2.57,2.57,0,0,1,.1-1.73",
    transform: "translate(0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M306.23,92.67a7.6,7.6,0,0,1-2.63-.56.72.72,0,1,1,.55-1.34c.65.26,2.23.68,2.91.27a.75.75,0,0,0,.36-.67c.26-2.54-.43-11.05-.44-11.14a.73.73,0,0,1,.67-.78.72.72,0,0,1,.78.66c0,.36.71,8.73.44,11.41a2.24,2.24,0,0,1-1.06,1.77,3.06,3.06,0,0,1-1.58.38",
    transform: "translate(0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.24,96.36c-.59,3-2.57,8.49-9.22,8.49s-8.54-5-9.18-8.49Z",
    transform: "translate(0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M306.11,108.64a7.57,7.57,0,0,1-3.54-1,.72.72,0,1,1,.75-1.24,6.27,6.27,0,0,0,2.79.78,6,6,0,0,0,2.65-.78.72.72,0,0,1,1,.24.73.73,0,0,1-.24,1,7.31,7.31,0,0,1-3.41,1",
    transform: "translate(0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329,83.13c.56-3.13,1.11-7.16.71-9.22-.72-3.66-3.67-5.81-2.69-9.33s-2.65-7.32-5.33-7.95-8.93.73-15.09-2.27c-5.88-2.86-16.1-.81-17.77,3-2,4.68.73,5.12-4.77,10.18-2.19,2,.41,7.26.78,10.67a23,23,0,0,1,.13,4l0,.86h-6.58c-.73-5.29-1.14-11.11-1.37-16a16.6,16.6,0,0,1,10.37-16.26c9.4-3.7,23.67-6.64,37.21,1.22a16.71,16.71,0,0,1,8.24,14.16,124.88,124.88,0,0,1-.8,16.87Z",
    transform: "translate(0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M281.66,85.92a26.68,26.68,0,0,0-.4-5c-.4-2.28-1.07-4.35-3.4-5.3-1.88-.77-3.88-.78-5.31,1.33-3.51,5.21.4,21.42,9,17.67Z",
    transform: "translate(0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M279.89,89.85a.72.72,0,0,1-.58-.66c-.38-4.92-4.83-7.77-4.87-7.8a.72.72,0,0,1-.23-1,.73.73,0,0,1,1-.23c.21.13,5.11,3.25,5.55,8.92a.73.73,0,0,1-.67.78h-.2",
    transform: "translate(0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M275.49,86.53a.77.77,0,0,1-.37-.19.74.74,0,0,1,0-1,6.55,6.55,0,0,1,3.1-1.62.72.72,0,0,1,.87.54.71.71,0,0,1-.54.87,5.33,5.33,0,0,0-2.39,1.22.7.7,0,0,1-.66.21",
    transform: "translate(0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M268,132.8c10.62,16.1,51.28,71.78,60.46,78.24,11.94,8.42,44.49,20.39,63.19,32.88,6.35,4.24-8.66,16.24-8.66,16.24s-45.56-12.81-66.08-25.91c-5.81-3.71-29.95-27.89-45.34-49.34-5.28-7.35-13.85-17.56-15.09-28.41C255,144,259,137.32,268,132.8",
    transform: "translate(0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M348.56,277.75H475.23a2.93,2.93,0,0,0,2.93-2.93V264.73a2.93,2.93,0,0,0-2.93-2.93H348.56a2.93,2.93,0,0,0-2.93,2.93v10.09a2.93,2.93,0,0,0,2.93,2.93",
    transform: "translate(0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 345.63,
    y: 261.8,
    width: 132.52,
    height: 15.95,
    rx: 2.93
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M478.13,277.75,503,184.46a8.25,8.25,0,0,0-8-10.38H440.26a8.26,8.26,0,0,0-7.95,6l-27.43,97.65Z",
    transform: "translate(0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M432.31,180.11,405.1,277h-6.26L426,180.11a8.26,8.26,0,0,1,7.95-6h6.26a8.24,8.24,0,0,0-7.94,6",
    transform: "translate(0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M432.31,180.11,405.1,277h-6.26L426,180.11a8.26,8.26,0,0,1,7.95-6h6.26A8.24,8.24,0,0,0,432.31,180.11Z",
    transform: "translate(0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.4,230.1c-1.42,6.15,2.41,11.14,8.56,11.14s12.3-5,13.72-11.14S466.27,219,460.12,219s-12.3,5-13.72,11.15",
    transform: "translate(0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M188.4,278.62a9.7,9.7,0,0,1-8.67-2.69,8,8,0,0,1-2.41-5.19v-.08c0-12.89-15.79-12-20.87-27.79s15-17.08,26.48-7.35c8.25,7,18.15-2.78,30.14,5.38,10.41,7.08,4.61,24.52,21.69,19.07,5.45-1.75,10.34-.07,14.46,3a24.48,24.48,0,0,1,9.12,14l-1.36,1c-33.69,20.64-48.87-2.61-68.58.69",
    transform: "translate(0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M221.77,277.93l-44.65-28.67a1.28,1.28,0,1,1,1.39-2.16l48,30.83Z",
    transform: "translate(0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.86,189.05c1.14-17,1.32-34.8.06-46.61-1.65-15.43-5.39-26.17-11.1-31.92a1,1,0,0,0-1.38,0,1,1,0,0,0,0,1.37C229.43,122,233,149,229.85,190Z",
    transform: "translate(0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229.3,128.81s8.14,0,7.56-14.32c0,0-12.45,3.55-7.56,14.32",
    transform: "translate(0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230,136.17s.44-8.12-13.87-8.34c0,0,2.85,12.63,13.87,8.34",
    transform: "translate(0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.76,116.1s3.12-7.51-10.3-12.49c0,0-1.52,12.86,10.3,12.49",
    transform: "translate(0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.81,150.94s7.66,2.74,12-10.92c0,0-12.92-.87-12,10.92",
    transform: "translate(0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.37,158.54s1.84-7.93-12.22-10.62c0,0,.62,12.94,12.22,10.62",
    transform: "translate(0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.8,169s7.61,2.88,12.16-10.69c0,0-12.9-1.12-12.16,10.69",
    transform: "translate(0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.31,277.52a32.9,32.9,0,0,1,.74-6c4.18-19.13-7.19-22.74-22.18-28.78s-16.77-24-6.15-38.9-8.46-26.9-1.44-49.35,31.41-7.51,36.75,13.18c3.83,14.88,23.33,11.66,30.55,30.95,6.27,16.75-14.75,32.22,9.53,39.9,7.75,2.45,12,8.4,14.28,15.37a34.69,34.69,0,0,1-.87,23.68Z",
    transform: "translate(0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M237,277.52,197,178.8a1.83,1.83,0,0,1,3.39-1.37L241,277.52Z",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "209.51 87.68 161.22 106.82 184.94 121.64 209.51 87.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "209.51 87.68 173.25 114.45 173.25 124.02 168.55 112.63 209.51 87.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "178.65 116.56 173.25 124.02 173.25 114.45 178.65 116.56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 136.5,
    y: 277.93,
    width: 366.82,
    height: 25.53,
    rx: 12.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1244.51,201.17c0,3.54.18,13.64-6.24,21.12-3.5,4.07-7,5.13-10.65,11s-2,8.09-4.78,11.39c-6.52,7.74-25.24,7.32-32.32-1.1-2.8-3.33-1.71-5.46-5.88-11-3.91-5.22-7.1-6.33-10.28-9.55-7.33-7.42-7.34-18.72-7.34-21.85,0-16.76,15-38.74,38.74-38.74s38.53,22.15,38.75,38.74",
    transform: "translate(0)"
  })))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1244.51,201.17c0,3.54.18,13.64-6.24,21.12-3.5,4.07-7,5.13-10.65,11s-2,8.09-4.78,11.39c-6.52,7.74-25.24,7.32-32.32-1.1-2.8-3.33-1.71-5.46-5.88-11-3.91-5.22-7.1-6.33-10.28-9.55-7.33-7.42-7.34-18.72-7.34-21.85,0-16.76,15-38.74,38.74-38.74s38.53,22.15,38.75,38.74",
    transform: "translate(0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1220.63,250.21h-27.78a5.15,5.15,0,1,1,0-10.29h27.78a5.15,5.15,0,1,1,0,10.29",
    transform: "translate(0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1221.57,264.14h-28.19a4.95,4.95,0,1,1,0-9.89h28.19a4.95,4.95,0,0,1,0,9.89",
    transform: "translate(0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1220.82,278.48h-26.7a5.7,5.7,0,0,1,0-11.39h26.7a5.7,5.7,0,0,1,0,11.39",
    transform: "translate(0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1201.11,239.92s2.18-19.95-1-26-7.69,4.78-3.15,5.32,8.13-1.94,10.47-5.56-3.6-8.95-3-2.66,8.46,5.8,10.88,6,.48-11.12-2.18-6.53-.48,6.77.73,10.4.48,19,.48,19",
    transform: "translate(0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1196.83,170.58c2.38,2.7.55,8.21-4.08,12.29s-10.33,5.2-12.72,2.49-.55-8.21,4.09-12.29,10.33-5.2,12.71-2.49",
    transform: "translate(0)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1200.2,168.64c3.34,3.8.78,11.51-5.72,17.23s-14.48,7.29-17.82,3.49-.77-11.5,5.73-17.23,14.47-7.28,17.81-3.49",
    transform: "translate(0)"
  })))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1215.55,291.06h-14.34a6.15,6.15,0,0,1-6.13-6.13v-2.74a6.15,6.15,0,0,1,6.13-6.13h14.34a6.15,6.15,0,0,1,6.13,6.13v2.74a6.15,6.15,0,0,1-6.13,6.13",
    transform: "translate(0)"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1240.55,
    y1: 162.61,
    x2: 1255.58,
    y2: 151.71
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1212.23,
    y1: 156.05,
    x2: 1212.23,
    y2: 137.49
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1187.2,
    y1: 158.75,
    x2: 1178.64,
    y2: 142.27
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1168.65,
    y1: 174.37,
    x2: 1152.57,
    y2: 165.09
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1161.23,
    y1: 195.36,
    x2: 1142.66,
    y2: 195.36
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1163.11,
    y1: 216.54,
    x2: 1146.67,
    y2: 225.17
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1248.31,
    y1: 187.01,
    x2: 1266.86,
    y2: 187.71
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1250.91,
    y1: 212.12,
    x2: 1267.76,
    y2: 219.92
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1462.07,
    cy: 231.24,
    r: 28.8
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1496.92,241.18h19.15a0,0,0,0,1,0,0v65.43a8.76,8.76,0,0,1-8.76,8.76h-1.63a8.76,8.76,0,0,1-8.76-8.76V241.18A0,0,0,0,1,1496.92,241.18Z",
    transform: "translate(207.46 1090.36) rotate(-42.48)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M571.51,43.63l-61.7-1a6,6,0,0,0-6.08,5.89l-.46,28.94a6,6,0,0,0,5.89,6.08l5.06.08c.33,2,.48,7.19-6.5,10.72,0,0,18.17-.58,18.59-10.53l44.55.7a6,6,0,0,0,6.08-5.89l.45-28.94a6,6,0,0,0-5.88-6.07",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusn);
export default __webpack_public_path__ + "static/media/ABOUT US N.f3a1c35e130b1b758e743816de11099d.svg";
export { ForwardRef as ReactComponent };